import { CloudIcon, IconButtonProps, IconButton, blue } from "@flat-ui";
import { Box, CircularProgress, Stack } from "@mui/material";
import { ForwardedRef, forwardRef } from "react";

type Props = Omit<IconButtonProps, "children"> & {
  /** True if the button should spinner */
  isLoading: boolean;
};

/** Renders the button to open the progress overview menu that can show the progress of the file upload */
export const ProgressOverviewButton = forwardRef(
  (
    { isLoading, ...rest }: Props,
    ref: ForwardedRef<HTMLButtonElement>
  ): JSX.Element => {
    return (
      <IconButton ref={ref} {...rest}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            transform: "scale(1.25)",
          }}
          data-testid="progress-overview-button"
        >
          <CircularProgress
            variant={isLoading ? "indeterminate" : "determinate"}
            value={rest.disabled ? 0 : undefined}
            size="100%"
            sx={{ color: blue[500] }}
          />
          <Box sx={{ position: "absolute" }}>
            {/* TODO: Change the icon https://faro01.atlassian.net/browse/ST-2010 */}
            <CloudIcon sx={{ width: "100%", height: "100%", p: "10%" }} />
          </Box>
        </Stack>
      </IconButton>
    );
  }
);
